module.exports = __webpack_public_path__ + "img/3.42523f5a.png";